(() => {
  'use strict';


  function initSellingPlanPopups(container = document) {

    const triggers = container.querySelectorAll(
      '[data-selling-plan-popup-trigger]'
    );


    triggers.forEach((trigger) => {

      if (
        trigger.dataset.sellingPlanPopupInitialized === 'true'
      ) {
        return;
      }


      trigger.dataset.sellingPlanPopupInitialized = 'true';


      trigger.addEventListener('click', (event) => {

        event.preventDefault();


        const popupId =
          trigger.dataset.popupId;


        if (!popupId) return;


        const popup =
          document.getElementById(popupId);


        if (!popup) {

          console.warn(
            `Selling Plan Popup not found: ${popupId}`
          );

          return;
        }


        openPopup(popup);

      });

    });


    const popups = container.querySelectorAll(
      '[data-selling-plan-popup]'
    );


    popups.forEach((popup) => {

      if (
        popup.dataset.sellingPlanPopupInitialized === 'true'
      ) {
        return;
      }


      popup.dataset.sellingPlanPopupInitialized = 'true';


      setupPopup(popup);

    });

  }


  function setupPopup(popup) {

    const closeButtons =
      popup.querySelectorAll(
        '[data-selling-plan-popup-close]'
      );


    const choices =
      popup.querySelectorAll(
        '[data-selling-plan-choice]'
      );


    /*
     * Close buttons
     */

    closeButtons.forEach((button) => {

      button.addEventListener('click', () => {

        closePopup(popup);

      });

    });


    /*
     * Plan buttons
     */

    choices.forEach((choice) => {

      choice.addEventListener('click', () => {

        addToCart(
          popup,
          choice
        );

      });

    });

  }


  /*
   * OPEN POPUP
   */

  function openPopup(popup) {

    /*
     * Move popup to body.
     */

    if (!popup._placeholder) {

      popup._placeholder =
        document.createComment(
          'Selling Plan Popup'
        );


      popup.parentNode.insertBefore(
        popup._placeholder,
        popup
      );

    }


    document.body.appendChild(popup);


    /*
     * Show popup.
     */

    popup.hidden = false;


    /*
     * Reset loading state.
     */

    popup.dataset.addingToCart = 'false';


    popup.classList.remove(
      'is-adding'
    );


    /*
     * Enable plan buttons.
     */

    const choices =
      popup.querySelectorAll(
        '[data-selling-plan-choice]'
      );


    choices.forEach((choice) => {

      choice.disabled = false;

    });


    /*
     * Lock background.
     */

    document.documentElement.classList.add(
      'selling-plan-popup-open'
    );


    document.body.classList.add(
      'selling-plan-popup-open'
    );

  }


  /*
   * CLOSE POPUP
   */

  function closePopup(popup) {

    popup.hidden = true;


    /*
     * Return popup to original location.
     */

    if (
      popup._placeholder &&
      popup._placeholder.parentNode
    ) {

      popup._placeholder.parentNode.insertBefore(
        popup,
        popup._placeholder.nextSibling
      );


      popup._placeholder.remove();


      popup._placeholder = null;

    }


    /*
     * Unlock background.
     */

    document.documentElement.classList.remove(
      'selling-plan-popup-open'
    );


    document.body.classList.remove(
      'selling-plan-popup-open'
    );

    

  }


  /*
   * ADD TO CART
   */

  async function addToCart(
    popup,
    choice
  ) {

    /*
     * Prevent double clicks.
     */

    if (
      popup.dataset.addingToCart === 'true'
    ) {
      return;
    }


    const variantId =
      popup.dataset.variantId;


    const sellingPlanId =
      popup.dataset.sellingPlanId;


    if (!variantId) {

      showError(
        popup,
        'Product variant is missing.'
      );

      return;

    }


    const selectedPlan =
      choice.dataset.sellingPlanChoice;


    /*
     * Build cart item.
     */

    const item = {

      id: Number(variantId),

      quantity: 1

    };


    /*
     * Subscription
     */

    if (
      selectedPlan === 'subscription' &&
      sellingPlanId
    ) {

      item.selling_plan =
        Number(sellingPlanId);

    }


    /*
     * Loading state
     */

    popup.dataset.addingToCart =
      'true';


    popup.classList.add(
      'is-adding'
    );


    const choices =
      popup.querySelectorAll(
        '[data-selling-plan-choice]'
      );


    choices.forEach((button) => {

      button.disabled = true;

    });


    clearError(popup);


    try {

      const response =
        await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {

            method: 'POST',

            headers: {

              'Content-Type':
                'application/json',

              'Accept':
                'application/json'

            },

            body: JSON.stringify({

              items: [item]

            })

          }
        );


      const data =
        await response.json();


      if (!response.ok) {

        throw new Error(

          data.description ||
          data.message ||
          'Unable to add product to cart.'

        );

      }


      /*
       * Close popup.
       */

      closePopup(popup);


      /*
       * Refresh cart.
       */

      await refreshCart(data);

      document.body.classList.remove('overflow-hidden');


    } catch (error) {

      console.error(
        'Selling Plan Popup:',
        error
      );


      showError(
        popup,
        error.message ||
        'Something went wrong. Please try again.'
      );


      /*
       * Allow clicking again.
       */

      popup.dataset.addingToCart =
        'false';


      popup.classList.remove(
        'is-adding'
      );


      choices.forEach((button) => {

        button.disabled = false;

      });

    }

  }


  /*
   * REFRESH CART
   */

  async function refreshCart(
    addResponse
  ) {

    const cartDrawer =
      document.querySelector(
        'cart-drawer'
      );


    if (
      cartDrawer &&
      typeof cartDrawer.getSectionsToRender ===
        'function'
    ) {

      const sections =
        cartDrawer.getSectionsToRender();


      const sectionIds =
        sections.map(
          (section) => section.id
        );


      if (sectionIds.length) {

        try {

          const response =
            await fetch(
              `${window.Shopify.routes.root}cart?sections=${sectionIds.join(',')}`
            );


          const sectionsData =
            await response.json();


          cartDrawer.renderContents({

            ...addResponse,

            sections: sectionsData

          });


          return;

        } catch (error) {

          console.warn(
            'Could not refresh cart drawer:',
            error
          );

        }

      }

    }


    /*
     * Fallback
     */

    document.dispatchEvent(

      new CustomEvent(
        'cart:updated',
        {
          detail: addResponse
        }
      )

    );


    window.location.href =
      `${window.Shopify.routes.root}cart`;

  }


  /*
   * ERROR
   */

  function showError(
    popup,
    message
  ) {

    const errorBox =
      popup.querySelector(
        '[data-selling-plan-popup-error]'
      );


    if (!errorBox) {

      console.error(message);

      return;

    }


    errorBox.textContent =
      message;


    errorBox.hidden =
      false;

  }


  function clearError(
    popup
  ) {

    const errorBox =
      popup.querySelector(
        '[data-selling-plan-popup-error]'
      );


    if (!errorBox) return;


    errorBox.textContent =
      '';


    errorBox.hidden =
      true;

  }


  /*
   * ESC
   */

  document.addEventListener(
    'keydown',
    (event) => {

      if (
        event.key !== 'Escape'
      ) {
        return;
      }


      const popup =
        document.querySelector(
          '[data-selling-plan-popup]:not([hidden])'
        );


      if (popup) {

        closePopup(popup);

      }

    }
  );


  /*
   * INITIALIZE
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => initSellingPlanPopups()
    );

  } else {

    initSellingPlanPopups();

  }


  /*
   * SHOPIFY THEME EDITOR
   */

  document.addEventListener(
    'shopify:section:load',
    (event) => {

      initSellingPlanPopups(
        event.target
      );

    }
  );

})();